import { z } from 'zod';

export const POST_SCHEMA = z.object({
  approved: z.boolean(),
  request: z.number(),
});

export const GET_FILTER_SCHEMA = z.object({
  request: z.coerce.number(),
});